import React, { Component } from 'react';
import { Container, Form, Col, Button, Table, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios'
import { Redirect } from 'react-router-dom'

import { AdminNav, RequestModal, Loading } from '../../helpers';
import TextInput from 'react-autocomplete-input';
import { convertRiceTypeTHToEN, convertRiceTypeEN, convertRiceTypeENToTH } from '../../helpers/function';
const admin = require('firebase')

class RequestEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      validatedLicense: false,
      modalShow: false,
      licenseID: '',
      LicenseDetail: [],
      description: [{}],
      shippingDate: '',
      subID: 1,
      dataReady: false,
      Company: null,
      redirect: false,
      riceTitles: [],
      showErrorModal: false,
      modalContent: null,
      changwatsArray: [],
      amphoesArray: [],
      amphoesArrayFilltered: [],
      showRiceTypeModal: false,
      isRiceTypeModal: false,
      isTotalNumberComplete: false,
      isNewNumberComplete: false,
      isDupNumberComplete: false,
      isSurveyTHComplete: false,
      isSurveyENComplete: false,
      isCreateSurveyComplete: false,
      riceTypeIDAndNameTotalNumber: 'x',
      riceTypeIDAndNameNewNumber: 'x',
      riceTypeIDAndNameDupNumber: 'x',
      submitCount: 0,
      currentFocusIndex: 0,
      currentFocusIDName: 0,
      riceForSearch: []
    }
    this.HandleChange = this.HandleChange.bind(this)
    this.renderRiceType = this.renderRiceType.bind(this)
    this.handleRiceType = this.handleRiceType.bind(this)
    this.HandleChangeChangwats = this.HandleChangeChangwats.bind(this)
    this.spinnerAndCheck = this.spinnerAndCheck.bind(this)
    this.handleSearchCompleteCompany = this.handleSearchCompleteCompany.bind(this)
    this.handleSearchCompleteCompanyPaidBy = this.handleSearchCompleteCompanyPaidBy.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.HandleChangeAmphoes = this.HandleChangeAmphoes.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }
  componentWillMount() {
    let incomingData = this.props.history.location.state
    let date = new Date();
    let formatted_date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    this.setState({
      ...this.state,
      requestDate: formatted_date
    })
    let viewAllCompanyPromise = fetch(`https://backend1.riceinspections.com/testAB`).then((res) => {
      return res.json()
    })

    let viewAllRiceTitlesPromise = fetch(`https://backend1.riceinspections.com/testBC`).then((res) => {
      return res.json()
    })
    let getChangwatsPromise = axios.get(
      'https://raw.githubusercontent.com/ignitry/thai-tambons/master/dist/changwats.json',
    )
    let getAmphoesPromise = axios.get(
      'https://raw.githubusercontent.com/ignitry/thai-tambons/master/dist/amphoes.json',
    )
    let viewAllRiceTypeIDAndNamePromise = fetch('https://backend1.riceinspections.com/testE').then((res) => {
      return res.json()
    })
    Promise.all([viewAllCompanyPromise, viewAllRiceTitlesPromise, getChangwatsPromise, getAmphoesPromise, viewAllRiceTypeIDAndNamePromise])
      .then((res) => {
        let Company = res[0]
        let riceTitles = res[1]
        let changwatsArray = res[2].data
        let amphoesArray = res[3].data
        let viewAllRiceTypeIDAndName = res[4]

        let newChangwatsArray = []
        Object.keys(changwatsArray).map((idx) => {
          newChangwatsArray.push(changwatsArray[idx]['name']['th'])
        })
        console.log(amphoesArray)
        let newAmphoesArray = []
        Object.values(amphoesArray).map((amphoesData) => {
          newAmphoesArray.push(amphoesData['name']['th'])
        })

        this.setState({
          ...this.state,
          Company: Company,
          riceTitles: riceTitles,
          changwatsArray: newChangwatsArray,
          amphoesArray: newAmphoesArray,
          riceTypeIDAndName: viewAllRiceTypeIDAndName,
          incomingData,
        }, () => {
          let riceForSearch = []
          Object.values(this.state.riceTitles).map((title) => {
            let convertIndex = convertRiceTypeENToTH(title, this.state.riceTypeIDAndName)
            let convertIndexLength = convertIndex.length
            if (convertIndexLength == 1) {
              riceForSearch.push(convertIndex)
            } else if (convertIndexLength > 1) {
              Object.values(convertIndex).map((riceTitles) => {
                riceForSearch.push(riceTitles['riceTypeName'])
              })
            }
          })
          this.setState({
            ...this.state,
            riceForSearch: riceForSearch
          })
        })
      })
  }
  createRequest() {
    console.log(this.state.incomingData)
    this.setState({
      ...this.state,
      showRiceTypeModal: true,
    })

  }
  handleSubmitAll = () => {
    this.refs.form1.dispatchEvent(new Event('submit'))
  }
  handleSubmitModal = (obj, cb, idx) => {
    let currentState = this.state
    let newobj = { ...obj, licenseID: this.state.incomingData.licenseID }
    let newLicenseDetail = newobj
    let newLicenseDetail2 = {
      licenseID: this.state.incomingData.licenseID,
      subID: idx,
      destinationCity: obj.Destination,
      exchangeRate: obj.ExchangeRate,
      pricePerUnit: obj.PricePerUnit,
      bagQuantity: obj.Quantity,
      bagType: obj.QuantityUnit,
      quantity: newLicenseDetail['WeightLeft'],
      riceTypeID: convertRiceTypeEN(newLicenseDetail, this.state.riceTypeIDAndName),
    }
    newLicenseDetail = {
      ...newLicenseDetail['0'],
      ...newLicenseDetail2
    }
    let newState = {
      ...currentState,
      incomingData: {
        ...this.state.incomingData,
        description: {
          ...this.state.incomingData.description,
          [Object.keys(this.state.incomingData.description).length]: {
            ...newLicenseDetail,
          },
        },
      },
      LicenseDetail: newLicenseDetail,
    }

    this.setState(newState, () => { console.log(this.state) })
    cb()
  }

  handleSubmitAllModal = (arr, companyDescription, cb) => {
    let { licenseID } = this.state.incomingData;
    let description = this.state.incomingData.description
    let topIDX = 0
    let objArr = {}
    Object.keys(description).map((idx) => {
      if (Object.keys(description[idx]).length > 0) {
        objArr = {
          ...objArr,
          [topIDX]: description[topIDX],
        }
        topIDX++
      }
    })

    console.log(arr)

    arr.map((obj, idx) => {
      obj.licenseID = licenseID;
      obj.subID = idx;
      obj.quantity = obj['WeightLeft']
      obj.riceTypeID = convertRiceTypeEN(obj, this.state.riceTypeIDAndName)
      obj.destinationCity = obj.Destination
      obj.bagType = obj.QuantityUnit
      obj.netWeight = parseFloat((obj.WeightLeft / obj.Quantity) * 1000).toFixed(6)
      objArr = {
        ...objArr,
        [parseInt(topIDX) + parseInt(idx)]: obj,
      }
    })
    this.setState({
      ...this.state,
      incomingData: {
        ...this.state.incomingData,
        description: objArr,
      }
    }, () => { console.log(this.state) })
    cb();
  }
  HandleChangeDescription = (e, idx) => {
    if (e.target.id == 'grossWeight' || e.target.id == 'netWeight') {
      this.setState({
        ...this.state,
        incomingData: {
          ...this.state.incomingData,
          description: {
            ...this.state.incomingData.description,
            [idx]: {
              ...this.state.incomingData.description[idx],
              [e.target.id]: parseFloat(e.target.value),
            },
          },
        }
      })
    } else {
      this.setState({
        ...this.state,
        incomingData: {
          ...this.state.incomingData,
          description: {
            ...this.state.incomingData.description,
            [idx]: {
              ...this.state.incomingData.description[idx],
              [e.target.id]: e.target.value,
            },
          },
        }
      })
    }
  }
  handleDeleteDescription = (e, idx) => {
    let { LicenseDetail } = this.state;
    let newDescription = Object.assign({}, this.state.incomingData.description)
    console.log(this.state.incomingData.description)
    delete newDescription[idx];
    let newLicense = LicenseDetail.filter((license, index) => index !== idx)


    this.setState({
      ...this.state,
      LicenseDetail: newLicense,
      incomingData: {
        ...this.state.incomingData,
        description: Object.values(newDescription)
      }
    }, () => console.log(this.state))
  }


  HandleChange = (e) => {
    if (e.target.id == 'shippingDate') {
      console.log(e.target.value)
      let time = e.target.value.slice(parseInt(e.target.value.length) - 5, e.target.value.length)
      let dateTime = e.target.value.slice(0, 10)
      this.setState({
        ...this.state,
        incomingData: {
          ...this.state.incomingData,
          'shippingTime': time,
          [e.target.id]: dateTime,
        }
      }, () => {
        let year = this.state.incomingData.shippingDate.slice(0, 4)
        console.log(`${dateTime}T${this.state.incomingData.shippingTime}`)
        if (year > 2500) {
          if (year > 2500) {
            year -= 543
          }
          let date = this.state.incomingData.shippingDate.slice(4, this.state.incomingData.shippingDate.length)
          this.state.incomingData.shippingDate = `${year}${date}`
        }
      })
    } else {
      this.setState({
        ...this.state,
        incomingData: {
          ...this.state.incomingData,
          [e.target.id]: e.target.value,
        }
      })
    }
  }
  // HandleChangeChangwats = (e) => {
  //   const changeChangwatToID = (EN)=>{
  //     let output = null
  //     Object.keys(this.state.changwatsArray).map((changwatID)=>{
  //       if(this.state.changwatsArray[changwatID]['name']['en'] == EN){
  //         output = changwatID
  //       }
  //     })
  //     return output
  //   }
  //   let changwatsEN = e.target.value
  //   let newAmphoesArr = []
  //   Object.values(this.state.amphoesArray).map((amphoe)=>{
  //     if(amphoe.changwat_id == changeChangwatToID(changwatsEN)){
  //       newAmphoesArr.push(amphoe)
  //     }
  //   })
  //   this.setState({
  //     ...this.state,
  //     incomingData : {
  //       ...this.state.incomingData,
  //       [e.target.id]: changwatsEN,
  //     },
  //     amphoesArrayFilltered : newAmphoesArr,
  //   })
  // }
  HandleIntChange = (e) => {
    this.setState({
      ...this.state,
      incomingData: {
        ...this.state.incomingData,
        [e.target.id]: parseInt(e.target.value),
      }
    })
  }
  handleSubmit(event) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (form.checkValidity() === true) {
      event.preventDefault();
      this.setState({ dataReady: true })
      this.createRequest()
    }
    this.setState({ validated: true });
  }
  handleRiceType = (e, idx) => {
    this.setState({
      ...this.state,
      incomingData: {
        ...this.state.incomingData,
        description: {
          ...this.state.incomingData.description,
          [idx]: {
            ...this.state.incomingData.description[idx],
            riceTypeName: e,
          }
        }
      }
    })
  }
  modalClose = () => {
    this.setState({ modalShow: false })
  }
  modalShow = (e) => {
    e.preventDefault()
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation()
    }
    this.setState({ validatedLicense: true })
    // console.log(this.state.incomingData.licenseID.length)
    if (this.state.incomingData.licenseID.length === 13) {
      this.setState({ modalShow: true })
    }

  }
  renmodal = () => {
    if (this.state.modalShow) {
      console.log('show1')
      if (this.state.incomingData.licenseID.length === 13) {
        console.log('show')
        return (
          <RequestModal submit={this.handleSubmitModal} submitAll={this.handleSubmitAllModal} licenseID={this.state.incomingData.licenseID} show={this.state.modalShow} onHide={this.modalClose}></RequestModal>
        )
      }
    }
  }
  renderRiceType(riceParaGraph, idx) {
    let riceForSearch = this.state.riceForSearch
    let riceDescription = riceParaGraph['ProductDescription']
    let stripIndex = riceDescription.indexOf('บรรจุ')
    // if (stripIndex > 0) {
    //   let riceTypeID = riceDescription.slice(0, stripIndex).trim()
    //   this.state.incomingData.description[idx].riceTypeID = riceTypeID
    //   this.state.incomingData.description[idx].riceTypeName = riceTypeID
    //   return riceTypeID
    // } else {
    // console.log(this.state.incomingData.description[idx])
    if (stripIndex > 0 && this.state.incomingData.description[idx].riceTypeName === undefined) {
      let riceTypeID = riceDescription.slice(0, stripIndex).trim()
      this.state.incomingData.description[idx].riceTypeName = riceTypeID
      this.state.incomingData.description[idx].riceTypeID = riceTypeID
    }

    return (
      <div>
        <input tabIndex={-1} value={this.state.incomingData.description[idx].riceTypeName} onChange={(e) => { this.handleRiceType(e.target.value, idx) }} list="brow" />
        <datalist id="brow">
          {(() => {
            return riceForSearch.map((titileRice) => {
              return <option value={titileRice} />
            })
          })()}
        </datalist>
      </div>
    )
    // }

    // if (convertRiceType(riceParaGraph) === 'blank') {
    //   return (
    //     <select name="cars" id={idx} onChange={(e) => { this.handleRiceType(e) }}>
    //       <option>โปรดเลือก</option>
    //       {/* {console.log(this.state.riceTitles)} */}
    //       {Object.values(this.state.riceTitles).map((title) => {
    //         return (<option value={title}>{convertRiceTypeENToTH(title)}</option>)
    //       })}
    //     </select>
    //   )
    // } else {
    //   this.state['incomingData']['description'][idx]['riceTypeID'] = convertRiceTypeEN(riceParaGraph)
    //   return `${convertRiceType(riceParaGraph)}`
    // }
  }
  toggleModal = (content) => {
    const { showErrorModal } = this.state;
    this.setState({
      ...this.state,
      showErrorModal: !showErrorModal,
      modalContent: content,
    })
  }
  getModalContent = () => {
    const { modalContent } = this.state;
    switch (modalContent) {
      case 'error':
        return 'เกิดข้อผิดพลาด.'
      //Todo add error case
      default:
        return 'เกิดข้อผิดพลาด.'
    }
  }
  toggleRiceTypeModal = () => {
    const { showRiceTypeModal } = this.state
    this.setState({
      ...this.state,
      showRiceTypeModal: !showRiceTypeModal,
      isRiceTypeModal: false
    })
  }
  spinnerAndCheck = (isComplete) => {
    if (isComplete == 'complete') {
      return '✓'
    } else if (isComplete == 'loading') {
      return <Spinner animation="border" size="sm" variant="primary" />
    } else {
      return <div></div>
    }
  }
  handleChangeRiceNameToRiceType = (riceTypeIDInput, idx) => {
    let a = {
      ...this.state.incomingData,
    }
    a['description'][idx]['riceTypeID'] = riceTypeIDInput
    a['description'][idx]['wtf'] = riceTypeIDInput
    this.setState({
      ...this.state,
      incomingData: a
    }, () => { console.log(this.state) })
    // this.state.description[idx].riceTypeID = riceTypeID
  }

  getRiceTypeModalContent = () => {
    const description = this.state?.incomingData.description
    // console.log(this.state)
    if (description[0]?.['riceTypeName']) {
      let a = []
      let riceForSearch = []
      let alreadySubmit = true
      Object.values(this.state.riceTitles).map((title) => {
        riceForSearch.push(title)
      })
      Object.values(description).map((data, idz) => {
        if (convertRiceTypeTHToEN(data['riceTypeName'], this.state.riceTypeIDAndName)) {
          data['wtf'] = convertRiceTypeTHToEN(data['riceTypeName'], this.state.riceTypeIDAndName)
          a.push(
            <tr>
              <td><p>{data['riceTypeName']}</p></td>
              <td><p>{convertRiceTypeTHToEN(data['riceTypeName'], this.state.riceTypeIDAndName)}</p></td>
            </tr>
          )
        } else {
          alreadySubmit = false
          a.push(
            <tr>
              <td><p>{data['riceTypeName']}</p></td>
              <td>
                <Form.Group as={Col}>
                  <TextInput Component='input'
                    regex={''} spacer={''} maxOptions={10}
                    onChange={(e) => { this.handleChangeRiceNameToRiceType(e, idz) }}
                    className='form-control' trigger={''} options={riceForSearch} />
                </Form.Group>
              </td>
            </tr>
          )
        }
      })
      if (alreadySubmit && this.state.showRiceTypeModal) {
        console.log(alreadySubmit)
        this.handleSubmitCreateSurveySheet()
        return a
      } else {
        return a
      }
    }
  }
  handleSubmitCreateSurveySheet() {
    if (this.state.submitCount == 0) {
      this.state.submitCount = 1
      this.state.isHandleNetwork = false
      let arrCreateRiceTypeIDAndNamePromise = []
      Object.values(this.state.incomingData.description).map((data) => {
        if (data['riceTypeID']) {
          data['riceTypeID'] = data['riceTypeID'].replace(/\s+|\(+|\)+|\%+/g, '')
        } else if (data['wtf']) {
          data['riceTypeID'] = data['wtf'].replace(/\s+|\(+|\)+|\%+/g, '')
        }
        arrCreateRiceTypeIDAndNamePromise.push([axios.post('https://backend1.riceinspections.com/testAC',{ data: data })])
      })


      this.setState({
        ...this.state,
        isTotalNumberComplete: 'complete',
        isDupNumberComplete: 'loading',
        isNewNumberComplete: 'loading',
        isSurveyTHComplete: 'loading',
        isSurveyENComplete: 'loading',
        riceTypeIDAndNameTotalNumber: arrCreateRiceTypeIDAndNamePromise.length
      }) 

      // console.log(this.state.description)
      let a = Promise.all(arrCreateRiceTypeIDAndNamePromise).then((res) => {
        let dupNumber = 0
        let newNumber = 0
        Object.values(res).map((resData) => {
          if (resData['status'] == 'dup') {
            dupNumber += 1
          } else if (resData['status'] == 'new') {
            newNumber += 1
          }
        })
        this.setState({
          ...this.state,
          isDupNumberComplete: 'complete',
          isNewNumberComplete: 'complete',
          riceTypeIDAndNameNewNumber: newNumber,
          riceTypeIDAndNameDupNumber: dupNumber,
        })
      })
      Promise.all([a]).then(() => {
        this.setState({
          ...this.state,
          isCreateSurveyComplete: 'loading'
        }) 

        axios.post(
          'https://backend1.riceinspections.com/testBH',
          {
            data: { 'licenseID': this.state.incomingData },
          }
        )
        // axios.post(
        //   'https://backend1.riceinspections.com/testBH',
        //   { 'action': 'editSurveyRequestSheetV2', 'data': this.state.incomingData }
        // )
        
        .then((res) => {
          if (res.data) {
            this.setState({
              ...this.state,
              isCreateSurveyComplete: 'complete'
            })
            this.setState({
              ...this.state,
              // redirect: true,
              isPushNewData: false,
            })
            setTimeout(() => {
              this.props.history.push({
                pathname: '/requestEditTable',
                // state: this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id],
                state: {
                  timeShow: this.props.location.state.timeShow || new Date(),
                  timeValue: this.props.location.state.timeValue || new Date()
                }
              })
            }, 800)
          } else {
            this.toggleModal('error')
          }
        }).catch((err) => {
          this.toggleModal('error')
        })
      })
    }
  }
  handleSearchCompleteCompany(e) {
    this.setState({
      ...this.state,
      incomingData: {
        ...this.state.incomingData,
        ['companyID']: e
      }
    })
  }
  handleSearchCompleteCompanyPaidBy(e) {
    this.setState({
      ...this.state,
      incomingData: {
        ...this.state.incomingData,
        ['surveyPaidBy']: e
      }
    })
  }
  checkFocus(idx, IDName) {
    let currentFocusIndex = this.state.currentFocusIndex
    let currentFocusIDName = this.state.currentFocusIDName
    //  console.log(`idx = ${idx} IDName = ${IDName} currentFocusIDName = ${currentFocusIDName} currentFocusIndex = ${currentFocusIndex} `)
    if (currentFocusIDName == IDName && currentFocusIndex == idx) {
      console.log(`idx = ${idx} IDName = ${IDName} currentFocusIDName = ${currentFocusIDName} currentFocusIndex = ${currentFocusIndex} `)

      return true
    } else {
      return false
    }
  }
  handleKeyDown(e) {

    if (e.keyCode == '38') {
      // up arrow
      if (this.state.currentFocusIndex - 1 > 0) {
        this.setState({
          ...this.state,
          currentFocusIndex: parseInt(this.state.currentFocusIndex) - 1
        })
      }
    }
    else if (e.keyCode == '40') {
      // down arrow
      if (this.state.currentFocusIndex < this.state['incomingData']['description'].length) {
        this.setState({
          ...this.state,
          currentFocusIndex: parseInt(this.state.currentFocusIndex) + 1
        })
      }
    }
    else if (e.keyCode == '37') {
      // left arrow
      if (this.state.currentFocusIDName - 1 > 0) {
        this.setState({
          ...this.state,
          currentFocusIDName: parseInt(this.state.currentFocusIDName) - 1
        })
      }
    }
    else if (e.keyCode == '39') {
      // right arrow
      console.log(this.state.currentFocusIDName)
      if (this.state.currentFocusIDName + 1 < 4) {
        this.setState({
          ...this.state,
          currentFocusIDName: parseInt(this.state.currentFocusIDName) + 1
        })
      }
    }
  }
  HandleChangeAmphoes(e) {
    let incomingDataTemp = this.state.incomingData
    incomingDataTemp['surveyDistrict'] = e
    this.setState({
      incomingData: incomingDataTemp
    })
  }
  HandleChangeChangwats(e) {
    let changwatsEN = e
    let incomingDataTemp = this.state.incomingData
    incomingDataTemp['surveyProvince'] = changwatsEN
    this.setState({
      incomingData: incomingDataTemp
    })
  }
  handleKeyPress(e, name, idx) {
    // console.log(e.which, name)
    if (e.which == 13) {
      let resultIdx = parseInt(idx) + 1
      if (resultIdx < Object.values(this.state['incomingData']['description']).length) {
        document.getElementById(`${name}${resultIdx}`).focus()
        e.preventDefault()
      }
    }
  }

  render() {
    const { validated, validatedLicense, Company, showErrorModal } = this.state;
    const renmodal = this.renmodal()

    if (!Company) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Loading />
        </Container>
      )
    }
    if (this.state.redirect) {
      return <Redirect to="/JobCalendar" />
    } else if (this.state.incomingData) {
      let incomingData = this.state.incomingData
      let CompanyForSearch = []
      // console.log(Company)
      Object.values(Company).map((o) => {
        CompanyForSearch.push(o['companyNameTH'])
      })

      return (
        <Container tabIndex={-1}>
          <AdminNav></AdminNav>
          <Form
            ref="form1"
            noValidate
            validated={validated}
            onSubmit={e => this.handleSubmit(e)}
          >
            <Form.Row>
              <Form.Group as={Col} md="5">
                {/* <Form.Label>ชื่อบริษัท</Form.Label>
                <Form.Control as="select" required id="companyID" onChange={this.HandleIntChange} value={incomingData['companyID']} >
                  <option value={''}>โปรดเลือก</option>
                  {Object.keys(Company).map((a) => {
                    let c = Company[a]
                    return (
                      <option type="number" value={c.companyID}>{c.companyNameEN}</option>
                    )
                  })}
                </Form.Control> */}
                <Form.Label>ชื่อผู้ส่งออก</Form.Label>
                <br></br>
                <TextInput Component='input' value={incomingData['companyID']} regex={''} spacer={''} maxOptions={10} onChange={this.handleSearchCompleteCompany} className='form-control' trigger={''} options={CompanyForSearch} />

                <Form.Control.Feedback type="invalid">
                  โปรดเลือก
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="5">
                <Form.Label>วันเวลาที่จะบรรทุก</Form.Label>
                <Form.Control
                  required
                  type="datetime-local"
                  id="shippingDate" onChange={(e) => { this.HandleChange(e) }}
                  value={`${incomingData['shippingDate']}T${incomingData['shippingTime']}`}
                />
                <Form.Control.Feedback type="invalid">
                  กรุณาระบุวันที่
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row>

              <Form.Group as={Col} md="5">
                <Form.Label>ชื่อผู้ขอตรวจสอบ</Form.Label>
                <Form.Control type="text" required id="requestBy" onChange={this.HandleChange} value={incomingData['requestBy']} />
                <Form.Control.Feedback type="invalid">
                  กรุณาระบุชื่อผู้ขอตรวจสอบ
                </Form.Control.Feedback>
                <Form.Label>เรียกเก็บเงิน</Form.Label>
                {/* <Form.Control as="select" required id="surveyPaidBy" onChange={this.HandleIntChange} value={incomingData['surveyPaidBy']}>
                  <option value="">โปรดเลือก</option>
                  {Object.keys(Company).map((a) => {
                    let c = Company[a]
                    return (
                      <option type="number" value={c.companyID}>{c.companyNameEN}</option>
                    )
                  })}
                </Form.Control> */}
                <br></br>
                <TextInput Component='input' value={incomingData['surveyPaidBy']} regex={''} spacer={''} maxOptions={10} onChange={this.handleSearchCompleteCompanyPaidBy} className='form-control' trigger={''} options={CompanyForSearch} />
 
              </Form.Group>
              <Form.Group as={Col} md="5">
                <Form.Label>เบอร์ติดต่อ</Form.Label>
                <Form.Control type="text" required id="tel" onChange={this.HandleChange} value={incomingData['tel']} />
                <Form.Control.Feedback type="invalid">
                  กรุณาระบุเบอร์ติดต่อ
                </Form.Control.Feedback>
                <Form.Label>เบอร์ติดต่อ</Form.Label>
                <Form.Control type="text" required id="tel" onChange={this.HandleChange} value={incomingData['tel']} />
                <Form.Control.Feedback type="invalid">
                  กรุณาระบุเบอร์ติดต่อ
                </Form.Control.Feedback>
              </Form.Group>



            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="3">
                <Form.Label>สถานที่ตรวจสอบ</Form.Label>
                <Form.Control type="text" id="surveyLocateName" onChange={this.HandleChange} required value={incomingData['surveyLocateName']} />
                <Form.Control.Feedback type="invalid">
                  กรุณาระบุ
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label>สถานที่ตรวจสอบ (EN)</Form.Label>
                <Form.Control type="text" id="godown" onChange={this.HandleChange} required value={incomingData['godown']} />
                <Form.Control.Feedback type="invalid">
                  กรุณาระบุ
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label>จังหวัด</Form.Label>
                {/* <Form.Control as="select" required id="surveyProvince" onChange={this.HandleChangeChangwats} value={incomingData['surveyProvince']}>
                  <option value="">โปรดเลือก</option>
                  {Object.keys(this.state.changwatsArray).map((a) => {
                    let c = this.state.changwatsArray[a]
                    return (
                      <option type="number" value={c.name.en}>{c.name.th}</option>
                    )
                  })}
                </Form.Control> */}
                <TextInput Component='input' regex={''} spacer={''} maxOptions={10} onChange={this.HandleChangeChangwats} className='form-control' trigger={''} options={this.state.changwatsArray} value={incomingData.surveyProvince} />

                <Form.Control.Feedback type="invalid">
                  กรุณาระบุ
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label>อำเภอ</Form.Label>
                {/* <Form.Control as="select" required id="surveyDistrict" onChange={this.HandleChange} value={incomingData['surveyDistrict']}>
                  <option value="">โปรดเลือก</option>
                  {Object.keys(this.state.amphoesArrayFilltered).map((a) => {
                    let c = this.state.amphoesArrayFilltered[a]
                    return (
                      <option type="number" value={c.name.en}>{c.name.th}</option>
                    )
                  })}
                </Form.Control> */}
                <TextInput Component='input' regex={''} spacer={''} trigger={''} maxOptions={5} id="surveyDistrict" onChange={this.HandleChangeAmphoes} className='form-control' options={this.state.amphoesArray} value={incomingData.surveyDistrict} />

                <Form.Control.Feedback type="invalid">
                  กรุณาระบุ
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Control style={{ display: 'none' }} type="submit" />
          </Form>
          <Form noValidate
            validated={validatedLicense}
            onSubmit={this.modalShow}>
            <Form.Row>
              <Form.Group as={Col} md="3">
                <Form.Control type="text" placeholder="เลขที่ใบอนุญาต" required id="licenseID" onChange={this.HandleChange} pattern="[0-9]{13}">
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  กรุณากรอกเลขที่ใบอนุญาตให้ถูกต้อง
                  </Form.Control.Feedback>
              </Form.Group>
              <Button variant="success" onClick={this.modalShow}>เพิ่มใบอนุญาต</Button>
            </Form.Row>
          </Form>
          {renmodal}

          <Table responsive>
            <thead>
              <tr>
                <th style={{ width: '4.5%', overflow: 'auto' }}></th>
                <th style={{ width: '4.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>รายการที่</p></th>
                <th style={{ width: '9.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>เลขที่ใบอนุญาต</p></th>
                <th style={{ width: '10.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ชนิดข้าว</p></th>
                <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ปริมาณ</p></th>
                <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ชนิดกระสอบ</p></th>
                <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>Grossweight</p></th>
                <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>Netweight</p></th>
                <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>Mask</p></th>
                <th style={{ width: '6.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ชื่อพาหนะ</p></th>
                <th style={{ width: '4.5%', overflow: 'auto' }}><p style={{ fontSize: '14px', fontWeight: 'normal' }}>ประเทศปลายทาง</p></th>
              </tr>
            </thead>
            <tbody>
              {Object.values(this.state['incomingData']['description']).map((a, idx) => {
                // console.log(this.state['incomingData']['description'][idx])
                let vechicleKey = 'vehicleName'
                Object.keys(a).map((findVechicleKey)=>{
                  console.log(findVechicleKey)
                  if(findVechicleKey.indexOf('vehicleName') != -1){
                    vechicleKey = findVechicleKey
                  }
                })
                return (
                  <tr>
                    <td style={{ overflow: 'hidden' }}><Button tabIndex={-1} variant="outline-danger" onClick={(e) => this.handleDeleteDescription(e, idx)}>ลบ</Button></td>
                    <td style={{ overflow: 'auto' }}><p tabIndex={-1} style={{ width: '6.5%', fontSize: '14px' }}>{(parseInt(this.state['incomingData']['description'][idx]['subID']) + 1)}</p></td>
                    <td style={{ overflow: 'auto' }}><p tabIndex={-1} style={{ fontSize: '14px' }}>{(a.licenseID)}</p></td>
                    <td style={{ overflow: 'auto' }}><p tabIndex={-1} style={{ fontSize: '12px' }}>{this.renderRiceType(a, idx)}</p></td>
                    <td style={{ overflow: 'hidden' }}><input tabIndex={-1} style={{ width: '100%' }} placeholder={'คงเหลือ ' + a.WeightLeft + ' ตัน'} id={`quantity${idx}`} onChange={(e) => { this.HandleChangeDescription(e, idx) }} value={this.state['incomingData']['description'][idx]['quantity']}></input></td>
                    <td style={{ overflow: 'hidden' }}><p style={{ width: '100%', fontSize: '14px' }}>{a.QuantityUnit}</p></td>
                    <td style={{ overflow: 'hidden' }}><input tabIndex={1} style={{ width: '100%' }} id={`grossWeight${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'grossWeight', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }} value={this.state['incomingData']['description'][idx]['grossWeight'] || this.state['incomingData']['description'][idx][`grossWeight${idx}`]}></input></td>
                    <td style={{ overflow: 'hidden' }}><input tabIndex={2} style={{ width: '100%' }} id={`netWeight${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'netWeight', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }} value={this.state['incomingData']['description'][idx]['netWeight'] || this.state['incomingData']['description'][idx][`netWeight${idx}`]}></input></td>
                    <td style={{ overflow: 'hidden' }}><input tabIndex={3} style={{ width: '100%' }} type="text" id={`logo${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'logo', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }} value={this.state['incomingData']['description'][idx]['logo'] || this.state['incomingData']['description'][idx][`logo${idx}`]}></input></td>
                    <td style={{ overflow: 'hidden' }}><input tabIndex={4} style={{ width: '100%' }} type="text" id={`vehicleName${idx}`} onKeyPress={(e) => { this.handleKeyPress(e, 'vehicleName', idx) }} onChange={(e) => { this.HandleChangeDescription(e, idx) }} value={this.state['incomingData']['description'][idx][vechicleKey]}></input></td>
                    {console.log(this.state['incomingData']['description'][idx][`vehicleName${idx}`])}
                    <td style={{ overflow: 'hidden' }}><p style={{ width: '100%', fontSize: '14px' }}>{a.Destination}</p></td>
                  </tr>
                )

              })
              }
            </tbody>
          </Table>
          <Modal show={showErrorModal} onClick={this.toggleModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>เกิดข้อผิดพลาด</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {this.getModalContent()}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={this.toggleModal}>ปิด</Button>
            </Modal.Footer>
          </Modal>


          <Modal show={this.state.showRiceTypeModal} onHide={() => { }} onClick={() => { }} centered>
            <Modal.Header onClick={this.toggleRiceTypeModal} closeButton>
              <Modal.Title> ชนิดข้าว </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Table bordered hover style={{ tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                    <th style={{ overflow: 'auto', fontSize: '11px' }}>ชื่อข้าว (ไทย) </th>
                    <th style={{ overflow: 'auto', fontSize: '11px' }}>ชื่อข้าว (อังกฤษ)</th>
                  </tr>
                </thead>
                <tbody >
                  {this.getRiceTypeModalContent()}
                </tbody>
              </Table>
              <p>ตรวจสอบชนิดข้าว {this.state.riceTypeIDAndNameTotalNumber} ชนิด {this.spinnerAndCheck(this.state.isTotalNumberComplete)}</p>
              <p>เพิ่มชนิดข้าว {this.state.riceTypeIDAndNameNewNumber} ชนิด {this.spinnerAndCheck(this.state.isNewNumberComplete)}</p>
              <p>ชนิดข้าวที่มีอยู่แล้ว {this.state.riceTypeIDAndNameDupNumber} ชนิด {this.spinnerAndCheck(this.state.isDupNumberComplete)}</p>
              <p>บันทึกสถานที่ตรวจสอบ (ไทย) {this.spinnerAndCheck(this.state.isSurveyTHComplete)}</p>
              <p>บันทึกสถานที่ตรวจสอบ (EN) {this.spinnerAndCheck(this.state.isSurveyENComplete)}</p>
              <p>กำลังบันทึกข้อมูล {this.spinnerAndCheck(this.state.isCreateSurveyComplete)}</p>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => { this.handleSubmitCreateSurveySheet() }}>ยืนยัน</Button>
            </Modal.Footer>
          </Modal>

          <Button style={{ float: 'right' }} onClick={this.handleSubmitAll}>ยืนยัน</Button>
        </Container>
      )
    }

  }
}

export default RequestEdit;
